module.exports = "/_next/static/images/d2a566fc113128a2f268af8207c1714b-cartao-proximo-ao-olho-xs@1x.jpg.webp";